import React, { FunctionComponent, useContext, useEffect } from "react";
import { AppPage, LoggedOutFooter } from "../../components";
import { useTranslate, useYearInTitle, hasGlobalSession } from "../../helpers";
import { AppStore } from "../../app/store";
import WhatMedicareCoverage from "./WhatMedicareCoverage";
import { Redirect, withRouter, RouteComponentProps } from "react-router";
import { AppState } from "../../@types";
import routes from "../../app/routes";
import {
  AnalyticsActionType,
  Ga4Event,
} from "../../app/contexts/Analytics/types";

export const beneRedirectTo = (state: AppState): string | null => {
  if (hasGlobalSession(state) && !state.csr) {
    return routes.summary.landingPage;
  }
  return null;
};

const QuestionRoutingPage: FunctionComponent<RouteComponentProps> = () => {
  const t = useTranslate();
  const { state, dispatch } = useContext(AppStore.AppContext);

  useEffect(() => {
    dispatch({
      type: AnalyticsActionType.SEND_GA4_EVENT,
      settings: {
        event_name: Ga4Event.PLAN_FINDER_STARTED,
      },
    });
  }, []);

  // heading is the shown on the page, i.e. <h1>.
  const heading = t("oe_questions.banner.title");
  // title is the page title.
  const title = useYearInTitle(heading, state.year);

  const redirectTo = beneRedirectTo(state);
  if (redirectTo) {
    return <Redirect to={redirectTo} />;
  }

  return (
    <AppPage heading={heading} title={title}>
      <span className="ds-u-visibility--screen-reader">
        {t("sr_only_additional_questions_may_appear")}
      </span>
      <div className="ds-u-margin-bottom--5 PlanPreferencePage">
        <WhatMedicareCoverage />
      </div>
      <LoggedOutFooter />
    </AppPage>
  );
};

export default withRouter(QuestionRoutingPage);
